export default function dateFormatBRL(data) {
	if (!data) return '';

	const date = new Date(String(data).substring(0, 10)+'T00:00:00.000-03:00');

	const value = date.toLocaleString('pt-BR', { dateStyle: 'short' });
	return value;
}
